import { render } from "./registro.vue?vue&type=template&id=36d5b1ab&ts=true"
import script from "./registro.vue?vue&type=script&lang=ts"
export * from "./registro.vue?vue&type=script&lang=ts"

import "./registro.vue?vue&type=style&index=0&id=36d5b1ab&lang=css"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__